import {HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {AuthService, UserRole} from '../services/auth.service';
import {inject, Injectable} from '@angular/core';


export const userTypeInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);
  const TOKEN = '__USER_TYPE__';

  if (!req.url.includes(TOKEN)) {
    return next(req);
  }

  let userType = authService.userTypeCreator();

  if (!userType) {
    return next(req);
  }

  if(userType === UserRole.CLIENT_SELLER){
    userType = 'CLIENT-SELLER'
  }

  const newReq = req.clone({
    url: req.url.replace(TOKEN, userType.toLowerCase())
  });

  return next(newReq);
};
